<style type="text/css" media="screen">
.filter-active {
  color: #1dc895 !important;
}

.custome-checkbox .v-input__slot {
  margin: 0px !important;
}

.filter-dialog {
  height: 550px !important;
  border-radius: 20px;
}
.scrolable-box {
  min-height: 280px;
  max-height: 280px;
  overflow-y: scroll;
}
.v-dialog--active {
  overflow-x: hidden !important;
}

.custome-date-picker .v-input {
  font-size: 13px !important;
}

.date-filter {
  width: max-content;
}
.date-filter .v-input__slot .v-input__append-inner {
  margin-top: 4px !important;
}
.date-filter .v-input__slot {
  padding: 0px 0px 0px 10px !important;
  min-height: 33px !important;
}

.day-width,
.month-width {
  width: 60px;
}
.year-width {
  width: 80px;
}
.scrolable-box-2 {
  min-height: 280px;
  max-height: 280px;
  overflow-y: scroll;
}
</style>

<template>
  <div class="shipment-filter">
    <v-dialog
      v-model="filter_dialog.flag"
      width="565"
      class="filter-dialog"
      :scollable="false"
    >
      <v-card>
        <v-card-text class="pa-0">
          <v-row>
            <v-col md="12" class="border-b">
              <p
                class="text-right pr-3"
                style="margin-bottom: -10px !important"
              >
                <v-icon
                  color="#8F8F8F"
                  small
                  @click="filter_dialog.flag = false"
                >
                  mdi-window-close
                </v-icon>
              </p>
              <p class="page-title text-center">
                {{ $lang.FILTER_WALLET.toUpperCase() }}
              </p>
            </v-col>
          </v-row>
          <v-row class="border-b px-4">
            <v-col md="4" class="border-r pl-4">
              <p class="filter-sub-title">{{ $lang.FILTER_USING }}</p>

              <div
                v-for="(item, i) in filter_option"
                :key="i"
                class="py-1 my-1 cursor-pointer"
                @click="step = i + 1"
              >
                <span
                  class="filter-options"
                  :class="step == i + 1 ? 'filter-active' : ''"
                  v-if="item"
                  >{{ item }}</span
                >
              </div>
            </v-col>
            <!--  filter section -->
            <v-col md="8" class="border-r px-0 scrolable-box">
              <v-stepper v-model="step" class="elevation-0">
                <v-stepper-items>
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <!-- $$$$$$$$$$$$$$ Agent FILTER $$$$$$$$$$$$$-->
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <v-stepper-content step="1" class="pa-0 pl-2">
                    <div class="mb-3">
                      <v-text-field
                        v-model="agent_serch_query"
                        :placeholder="$lang.SEARCH"
                        @keyup="getAgentList"
                        outlined
                        dense
                        rounded
                        append-icon="mdi-magnify"
                        class="mt-1"
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="scrolable-box-2">
                      <v-checkbox
                        v-for="agent in agent_list"
                        :key="agent.id"
                        v-model="filter_data.agent_id_list"
                        :label="agent.agent_name"
                        :value="agent.id"
                        @change="manageCount"
                        class="ml-2 mt-0 custome-checkbox"
                      >
                        <template v-slot:label>
                          <div>
                            <p class="sub-title-text-dark">
                              {{ agent.agent_name }}
                              <small class="secondary-text fs-12"
                                >({{ agent.agent_type }})</small
                              >
                            </p>
                            <p class="select-secondary-text">
                              {{ agent.agent_phone_number }}
                            </p>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </v-stepper-content>

                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <!-- $$$$$$$$$$$$$$ DATE FILTER $$$$$$$$$$$$$-->
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->

                  <v-stepper-content step="2" class="px-5">
                    <div class="date-filter">
                      <!-- from date  -->
                      <div>
                        <p class="filter-sub-title">{{ $lang.FROM }}</p>
                        <v-menu
                          bottom
                          origin="center center"
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="d-flex flex-row elevation-0 custome-date-picker"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.DAY }}
                                </p>
                                <v-text-field
                                  v-model="filter_form_day"
                                  placeholder="DD"
                                  outlined
                                  dense
                                  single-line
                                  maxlength="2"
                                  readonly
                                  append-icon="mdi-menu-down"
                                  class="day-width"
                                ></v-text-field>
                              </v-card>
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.MONTH }}
                                </p>
                                <v-text-field
                                  v-model="filter_form_month"
                                  placeholder="MM"
                                  outlined
                                  dense
                                  single-line
                                  readonly
                                  append-icon="mdi-menu-down"
                                  class="month-width"
                                ></v-text-field>
                              </v-card>
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.YEAR }}
                                </p>
                                <v-text-field
                                  v-model="filter_form_year"
                                  placeholder="YYYY"
                                  outlined
                                  dense
                                  single-line
                                  append-icon="mdi-menu-down"
                                  class="year-width"
                                ></v-text-field>
                              </v-card>
                            </div>
                          </template>
                          <v-date-picker
                            v-model="form_date"
                            :max="today"
                            @change="dateChangeHandler()"
                            style="z-index: 5"
                          >
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <!--  To date -->
                      <div>
                        <p class="filter-sub-title">{{ $lang.TO }}</p>
                        <v-menu
                          bottom
                          origin="center center"
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="d-flex flex-row elevation-0 custome-date-picker"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.DAY }}
                                </p>
                                <v-text-field
                                  v-model="filter_to_day"
                                  placeholder="DD"
                                  outlined
                                  dense
                                  single-line
                                  maxlength="2"
                                  readonly
                                  append-icon="mdi-menu-down"
                                  class="day-width"
                                ></v-text-field>
                              </v-card>
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.MONTH }}
                                </p>
                                <v-text-field
                                  v-model="filter_to_month"
                                  placeholder="MM"
                                  outlined
                                  dense
                                  single-line
                                  readonly
                                  append-icon="mdi-menu-down"
                                  class="month-width"
                                ></v-text-field>
                              </v-card>
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.YEAR }}
                                </p>
                                <v-text-field
                                  v-model="filter_to_year"
                                  placeholder="YYYY"
                                  outlined
                                  dense
                                  single-line
                                  append-icon="mdi-menu-down"
                                  class="year-width"
                                ></v-text-field>
                              </v-card>
                            </div>
                          </template>
                          <v-date-picker
                            v-model="to_date"
                            :min="form_date"
                            :max="today"
                            @change="dateChangeHandler()"
                          >
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </div>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col md="6">
              <p class="sub-title-text-dark">
                {{ $lang.FILTER_SELECTED }}: {{ filter_count }}
              </p>
            </v-col>
            <v-col md="6" class="text-right">
              <v-btn text color="primary" @click="clearFIlter" class="mr-3">
                <span class="messge-text-green fs-13 underline">
                  {{ $lang.CLEAR_ALL }}
                </span>
              </v-btn>
              <v-btn color="primary" @click="applyFilter" width="90">
                <span class="fs-13 font-bold px-4"> {{ $lang.APPLY }} </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
export default {
  props: ["filter_data", "filter_dialog"],
  data() {
    return {
      step: 1,
      dialog: true,
      filter_option: ["Agent", "Date"],
      agent_list: [],
      agent_serch_query: "",

      wholesaler_search_query: "",
      wholesaler_list: [],

      // 'Wholesaler','Reciver',
      today: new Date().toISOString().substr(0, 10),
      form_date: new Date().toISOString().substr(0, 10),
      to_date: new Date().toISOString().substr(0, 10),

      filter_form_day: null,
      filter_form_month: null,
      filter_form_year: null,
      filter_to_day: null,
      filter_to_month: null,
      filter_to_year: null,

      filter_count: 0,
    };
  },
  created() {
    this.getWholesalerList();
    this.setDisplayDate();
    this.getAgentList();
  },

  methods: {
    getWholesalerList() {
      const self = this;
      let params = {
        search_query: self.wholesaler_search_query,
      };
      self.loading = true;
      const successHandler = (response) => {
        if (response.data.success)
          self.wholesaler_list = response.data.wholesaler_list;
      };
      const finallyHandler = () => {
        self.loading = false;
      };
      self.request_GET(
        self,
        self.$urls.WHOLESALER_LIST,
        params,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },
    /* frtching agent list  list */
    getAgentList() {
      const self = this;
      self.filter_agent_type = status;
      let params = {
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.agent_serch_query,
      };

      self.table_loading = true;
      const successHandler = (response) => {
        self.agent_list = response.data.agent_list;
      };
      const finallyHandler = () => {
        self.table_loading = false;
      };
      self.request_GET(
        self,
        self.$urls.AGENT_LIST,
        params,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },
    manageCount() {
      let a_len = this.filter_data.agent_id_list.length;
      let d_len = 0;
      if (this.filter_data.filter_date_from) d_len = 1;
      this.filter_count = d_len + a_len;
    },
    applyFilter() {
	const self=this
      this.filter_data.filter_count = this.filter_count;
      this.$store.dispatch("payout/setPayoutFilter", {
        agent_id_list: self.filter_data.agent_id_list,
        filter_date_from: self.filter_data.filter_date_from,
        filter_date_to: self.filter_data.filter_date_to,
        filter_count: self.filter_data.filter_count,
      });
      this.filter_dialog.flag = false;
      this.$emit("filter");
    },

    clearFIlter() {
      this.filter_data.agent_id_list = [];
      this.filter_data.filter_date_from = "";
      this.filter_data.filter_date_to = "";
      this.manageCount();
    },
    dateChangeHandler() {
      this.filter_data.filter_date_from = this.form_date;
      this.filter_data.filter_date_to = this.to_date;
      this.setDisplayDate();
      this.manageCount();
    },
    setDisplayDate() {
      console.log(this.form_date);
      let from_date_arr = this.form_date.toString().split("-");
      this.filter_form_day = from_date_arr[2];
      this.filter_form_month = from_date_arr[1];
      this.filter_form_year = from_date_arr[0];

      let to_date_arr = this.to_date.toString().split("-");
      this.filter_to_day = to_date_arr[2];
      this.filter_to_month = to_date_arr[1];
      this.filter_to_year = to_date_arr[0];
    },
  },
};
</script>